import { render, staticRenderFns } from "./LinkUserToMembershipByCode.vue?vue&type=template&id=51d96f8e"
import script from "./LinkUserToMembershipByCode.vue?vue&type=script&lang=ts"
export * from "./LinkUserToMembershipByCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports